module.exports = __webpack_public_path__ + "fonts/8a522ca84dbd2c005e37396122f1d3dd.txt";